(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soil-sage-wholesale"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('soil-sage-storefront')) {
  customElements.define('soil-sage-storefront', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.active = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hero = this.querySelector('.ss2-hero');
      this.pauseButton = this.querySelector('.ss2-pause');
      const show = n => {
        this.active = (n + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.active; });
        this.querySelectorAll('[data-dot]').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.active)));
        this.hero.dataset.active = this.active;
      };
      const updatePause = () => {
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        this.pauseButton.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      };
      this.querySelector('.ss2-next').addEventListener('click', () => show(this.active + 1), {signal});
      this.querySelector('.ss2-prev').addEventListener('click', () => show(this.active - 1), {signal});
      this.querySelectorAll('[data-dot]').forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.dot)), {signal}));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; updatePause(); }, {signal});
      this.hero.addEventListener('mouseenter', () => { this.hovered = true; }, {signal});
      this.hero.addEventListener('mouseleave', () => { this.hovered = false; }, {signal});
      this.hero.addEventListener('focusin', () => { this.focused = true; }, {signal});
      this.hero.addEventListener('focusout', event => { this.focused = this.hero.contains(event.relatedTarget); }, {signal});
      this.timer = setInterval(() => { if (!this.paused && !this.hovered && !this.focused && !document.hidden) show(this.active + 1); }, 6500);
      updatePause(); show(0);
      const catalog = this.querySelector('.ss2-catalog');
      const search = this.querySelector('.ss2-search input');
      const filters = [...this.querySelectorAll('[data-filter]')];
      this.category = 'all';
      const apply = () => {
        const term = search.value.trim().toLowerCase();
        const checked = filters.filter(input => input.checked).map(input => input.value);
        let visible = 0;
        this.querySelectorAll('[data-product-category]').forEach(card => {
          card.hidden = !(this.category === 'all' || card.dataset.productCategory === this.category) || (checked.length > 0 && !checked.includes(card.dataset.productCategory)) || !card.dataset.search.includes(term);
          if (!card.hidden) visible++;
        });
        this.querySelector('.ss2-count').textContent = `${visible} ${visible === 1 ? 'category' : 'categories'}`;
        this.querySelector('.ss2-empty').hidden = visible !== 0;
        this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      };
      this.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault(); this.category = button.dataset.category; search.value = ''; filters.forEach(input => { input.checked = false; }); apply(); catalog.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      }, {signal}));
      filters.forEach(input => input.addEventListener('change', () => { this.category = 'all'; apply(); }, {signal}));
      search.addEventListener('input', apply, {signal});
      this.querySelector('.ss2-search').addEventListener('submit', event => { event.preventDefault(); this.category = 'all'; filters.forEach(input => { input.checked = false; }); apply(); catalog.scrollIntoView({behavior:'smooth', block:'start'}); }, {signal});
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
